export const LOAN_APPLICATION_TYPE = {
  QUOTE: 'quote',
}

export type LoanApplicationTypes =
  typeof LOAN_APPLICATION_TYPE[keyof typeof LOAN_APPLICATION_TYPE]
